"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZNumericInput = void 0;
const React = __importStar(require("react"));
const LocalizedComponent_1 = require("../../languages/LocalizedComponent");
const kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
const __1 = require("../");
const styled_components_1 = __importDefault(require("styled-components"));
class ZNumericInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            raisedLabel: props.value || props.placeholder || props.defaultValue
                ? true
                : false,
            hovered: false,
            value: props.value || props.defaultValue
        };
        this.boundOnChangeHandler = this.onChangeHandler.bind(this);
        this.boundClearHandler = this.clearHandler.bind(this);
        this.input = React.createRef();
    }
    componentDidMount() {
        const me = this;
        if (me.input && me.input.current && me.input.current.element) {
            me.input.current.element.addEventListener("focus", (e) => {
                me.setState({ raisedLabel: true });
            });
            me.input.current.element.addEventListener("blur", function (e) {
                me.setState({
                    raisedLabel: me.props.value !== null || me.state.value !== null
                        ? true
                        : false
                });
            });
        }
    }
    render() {
        const { className, required, ...otherProps } = this.props;
        return (React.createElement(__1.RequiredDot, { required: required, raised: this.state.raisedLabel, raisedTransform: "down-10 right-3", loweredTransform: "down-24 left-2" },
            React.createElement("span", { className: [className, this.state.hovered ? "hovered" : ""].join(" "), onMouseEnter: e => this.setState({ hovered: true }), onMouseLeave: e => this.setState({ hovered: false }) },
                React.createElement(LocalizedComponent_1.LocalizedComponent, Object.assign({}, otherProps),
                    React.createElement(kendo_react_inputs_1.NumericTextBox, Object.assign({}, this.props, { format: {
                            minimumFractionDigits: this.props.decimals,
                            maximumFractionDigits: this.props.decimals
                        }, className: this.props.disabled ? "disabled" : undefined, onChange: this.boundOnChangeHandler, ref: this.input, value: this.props.value === undefined
                            ? this.state.value
                            : this.props.value }))),
                (this.props.value || this.state.value) &&
                    this.state.hovered &&
                    !this.props.disabled ? (React.createElement("span", { className: "k-icon k-clear-value k-i-close z-clear-button", role: "button", tabIndex: -1, title: "clear", onClick: this.boundClearHandler })) : null)));
    }
    onChangeHandler(e, value, touch) {
        this.props.onChange &&
            this.props.onChange(e, e.target.value || value, touch);
        if (!this.props.label) {
            this.setState({ raisedLabel: e.value === null ? false : true });
        }
        this.setState({ value: e.target.value || value });
    }
    clearHandler(event) {
        event.preventDefault();
        this.input &&
            this.input.current &&
            (() => {
                this.boundOnChangeHandler({ target: { value: null } }, null);
                this.setState({ value: null, raisedLabel: false });
            })();
    }
    setValue(value) {
        this.input &&
            this.input.current &&
            (() => {
                this.boundOnChangeHandler({ target: { value } }, value, false);
                this.setState({
                    value,
                    raisedLabel: value === null ? false : true
                });
            })();
    }
}
ZNumericInputComponent.defaultProps = {
    // Set defaults for woop fields
    placeholder: "",
    spinners: true,
    step: 1,
    iconType: "",
    iconId: "",
    iconClasses: "",
    decimals: 2,
    min: -9999999999.99,
    max: 9999999999.99,
    nan: false,
    zeroOnClear: false,
    label: ""
};
exports.ZNumericInput = styled_components_1.default(ZNumericInputComponent) `
   color: ${props => props.theme["input-color"]};
   position: relative;
   top: 1px;
   padding: 10px;
   display: inline-block;

   & .k-input,
   & .k-label {
      margin: 0px 3px 0px 5px;
   }
   & .k-numerictextbox .k-numeric-wrap .k-input {
      padding-bottom: 2px;
      padding-right: 35px;
      background: "inherit";
      font-family: ${props => props.theme["font-family"]};
   }
   & .k-numerictextbox:hover,
   &.hovered .k-numerictextbox {
      background: ${props => props.disabled ? null : props.theme["input-background-hover-color"]};
   }
   & .z-clear-button {
      position: absolute;
      display: block;
      bottom: 4px;
      right: 18px;
      opacity: 0.5;
      cursor: pointer;
   }
   & .k-numeric-wrap.k-numeric-wrap.k-numeric-wrap {
      &:hover {
         border-bottom-color: rgba(0, 0, 0, 0.87);
      }
      border-top: 0;
   }
`;
//# sourceMappingURL=ZNumericInput.js.map